import BaseModel from './BaseModel';
import cinech from '../assets/images/integrations/cinech.webp';
import eventival from '../assets/images/integrations/eventival.webp';
import fiona from '../assets/images/integrations/fiona.webp';
import kronos from '../assets/images/integrations/kronos.webp';
import json from '../assets/images/integrations/json.webp';
import own_it from '../assets/images/integrations/own_it.webp';
import ozu from '../assets/images/integrations/ozu.webp';
import shift72 from '../assets/images/integrations/shift72.webp';

/** Class representing a Ref. */
class Ref extends BaseModel {
    icone = () => {
        if (this.source === 'cinech')
            return cinech;
        if (this.source === 'eventival')
            return eventival;
        if (this.source === 'fiona')
            return fiona;
        if (this.source === 'kronos')
            return kronos;
        if (this.source === 'json')
            return json;
        if (this.source === 'dac-player')
            return own_it;
        if (this.source === 'shift72')
            return shift72;
        if (this.source === 'ozu')
            return ozu;

        return null;
    }

    display = () => {
        return [this.id, this.name].filter(Boolean).join(' - ');
    }
}

export default Ref;
